export const QUANTITY_PER_PAGE = 7;
export const HEADER_HEIGHT = 61;
export const HEIGHT_CELL_BODY = 92; 
export const HEIGHT_CELL_BODY_WITH_MARGIN = HEIGHT_CELL_BODY + 2; 
export const WIDTH_HOUR_CONTENT = "94px";
export const DEFAULT_ROW_SPAN = 4;
export const QUARTER_HEIGHT_CELL_BODY = HEIGHT_CELL_BODY/DEFAULT_ROW_SPAN;
// 60min equivalen a heightCellBody